// Sign-up password policy. Keep in step with validate_password() in backend/auth_utils.py.
export interface PasswordRule {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'At least 8 characters', test: p => p.length >= 8 },
  { id: 'upper', label: 'One uppercase letter', test: p => /[A-Z]/.test(p) },
  { id: 'number', label: 'One number', test: p => /[0-9]/.test(p) },
];

export const isPasswordValid = (password: string) => PASSWORD_RULES.every(rule => rule.test(password));
